export const prepend = "/";

export default function actionObjectCreator(descriptor) {
  return (name) => {
    var identifier = prepend + descriptor + name;
    var ret = {
      default:identifier,
      pending: identifier + "_PENDING",
      fulfilled: identifier + "_FULFILLED",
      rejected: identifier + "_REJECTED"
    };

    return ret;   
  };
}
 


// WEBPACK FOOTER //
// ./src/common/actionObjectCreator.js